import React from 'react';
import { styles } from '../styles/styles';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.footerContainer}>
        <div style={styles.footerLogo}>
            <img 
            src="/images/metro-logo.png" 
            alt="Metro Mowing Logo" 
            style={{ 
              height: '1.5rem', 
              width: 'auto', 
              marginRight: '0.5rem' 
            }}
          />
          <h3 style={styles.footerTitle}>Metro Mowing</h3>
        </div>
        <p style={styles.footerDescription}>
          Professional lawn care services for Apple Valley, Rosemount, Eagan, Burnsville, Lakeville & South Metro Minnesota
        </p>
        <div style={styles.footerLinks} className="footer-links">
          <a href="tel:6513137009" style={styles.footerLink}>
            (651) 313-7009
          </a>
          <a href="mailto:metromowingMN@gmail.com" style={styles.footerLink}>
            MetroMowingMN@gmail.com
          </a>
        </div>
        <div style={styles.footerCopyright}>
          <p>© 2025 Metro Mowing. Professional lawn care for Apple Valley, Rosemount, Eagan, Burnsville and Lakeville. All rights reserved. - </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;